import ReactDOM from 'react-dom';
import { useEffect, useRef } from 'react';

const modalRoot = document.getElementById('modal-root');

const ModalPortal = ({ children }) => {
    const modalElement = useRef(document.createElement('div')).current;

    useEffect(() => {
        modalElement.classList.add('modal-wrapper');
        modalRoot.appendChild(modalElement);

        return () => {
            modalRoot.removeChild(modalElement);
        }
    }, [modalElement]);

    return ReactDOM.createPortal(
        children,
        modalElement
    );
};

export default ModalPortal;